<template>
  <div class="dks">
    <dash-kpi-card v-for="kpi in kpisComputed" :key="kpi.color"
      :label="kpi.label"
      :value="kpi.value"
      :delta="kpi.delta"
      :pos="kpi.pos"
      :color="kpi.color"
      :icon-path="kpi.iconPath"
      :with-circle="kpi.withCircle"
      :spark="kpi.spark"
    />
  </div>
</template>

<script>
import DashKpiCard from './DashKpiCard.vue'

const DEFAULTS = [
  { label: 'Visualizações', color: 'blue',   iconPath: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z', withCircle: true,  value: '—', delta: '—', pos: true, spark: [4,5,4,6,5,7,8] },
  { label: 'Plays',         color: 'orange', iconPath: 'M5 3l14 9-14 9V3z',                              withCircle: false, value: '—', delta: '—', pos: true, spark: [3,4,3,5,6,5,7] },
  { label: 'Play Rate',     color: 'gold',   iconPath: 'M18 20V10M12 20V4M6 20v-6',                     withCircle: false, value: '—', delta: '—', pos: true, spark: [5,5,6,6,7,6,7] },
  { label: 'Engajamento',   color: 'green',  iconPath: 'M22 12h-4l-3 9L9 3l-3 9H2',                     withCircle: false, value: '—', delta: '—', pos: false, spark: [8,7,8,7,6,7,6] },
]

export default {
  name: 'DashKpiStrip',
  components: { DashKpiCard },
  props: {
    kpis: { type: Array, default: null },
  },
  computed: {
    kpisComputed() {
      if (!this.kpis) return DEFAULTS
      return this.kpis.map((k, i) => ({ ...DEFAULTS[i], ...k }))
    },
  },
}
</script>

<style>
.dks {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}
@media (max-width: 900px) { .dks { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 560px) { .dks { grid-template-columns: 1fr; } }
</style>
